module.exports = __webpack_public_path__ + "static/media/valeo-foods-ireland.6b724609.png";